import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

export const getShiftLogTasks = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/shift-log-tasks`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching shift log tasks:", error.response?.data || error);
    throw error;
  }
};

export const getShiftLogTaskById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/shift-log-tasks/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching shift log task:", error.response?.data || error);
    throw error;
  }
};

export const createShiftLogTask = async (taskData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/shift-log-tasks`, taskData);
    return response.data;
  } catch (error) {
    console.error("Error creating shift log task:", error.response?.data || error);
    throw error;
  }
};

export const updateShiftLogTask = async (id, taskData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/shift-log-tasks/${id}`, taskData);
    return response.data;
  } catch (error) {
    console.error("Error updating shift log task:", error.response?.data || error);
    throw error;
  }
};

export const deleteShiftLogTask = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/shift-log-tasks/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting shift log task:", error.response?.data || error);
    throw error;
  }
};
